export default __webpack_public_path__ + "static/media/comp1stImgTuto.449bfa02.jpg";